// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.7 8C10.7 9.49 9.49 10.7 8 10.7C6.51 10.7 5.3 9.49 5.3 8C5.3 6.51 6.51 5.3 8 5.3C9.49 5.3 10.7 6.51 10.7 8Z',
  'M13.05 8L14.6 8',
  'M11.57 11.57L12.67 12.67',
  'M8 13.05L8 14.6',
  'M4.43 11.57L3.33 12.67',
  'M2.95 8L1.4 8',
  'M4.43 4.43L3.33 3.33',
  'M8 2.95L8 1.4',
  'M11.57 4.43L12.67 3.33',
];
